/**
 * Created by juraj.homola on 4. 10. 2016.
 */
import reframe from 'nike-re-framejs';
import Immutable from 'immutable';

const getClock = function(matchData) {
    let newClock = Immutable.Map();
    if (typeof matchData.tick !== 'undefined') {
        newClock = newClock.set('tick', matchData.tick);
    }

    if (typeof matchData.clockStopped !== 'undefined') {
        newClock = newClock.set('clockStopped', matchData.clockStopped).set('timestamp', Date.now());
    }

    if (typeof matchData.time !== 'undefined') {
        newClock = newClock.set('time', matchData.time).set('timestamp', Date.now());
    }

    if (typeof matchData.countDown !== 'undefined') {
        newClock = newClock.set('countdown', matchData.countDown);
    }

    if (typeof matchData.eventStatus !== 'undefined') {
        if (typeof matchData.eventStatus.code !== 'undefined') {
            newClock = newClock.set('status', matchData.eventStatus.code);
        }
    }

    return newClock;
};

export const createClocksMap = function createClocksMap(events) {
    const result = {};
    events.forEach(event => {
        result[event.id] = getClock(event);
    });
    return Immutable.Map(result);
};

export const createClocksMapForScoreboard = function createClocksMap(events) {
    const result = {};
    events.forEach(event => {
        result[event.match.id] = getClock(event);
    });
    return Immutable.Map(result);
};

function matchCreated(actualMap, data) {
    return actualMap.setIn([data.event.id.toString()], getClock(data.event));
}

function matchDeleted(actualMap, data) {
    return actualMap.deleteIn([data.event.id.toString()]);
}

function processMatch(event, actualMap, data, matchCreatedHandler, matchDeletedHandler) {
    let resultMap = actualMap;
    if (event === 'CREATED' && matchCreatedHandler) {
        resultMap = matchCreatedHandler(actualMap, data);
    } else if (data.event && data.event.id) {
        if (event === 'DELETED' && matchDeletedHandler) {
            resultMap = matchDeletedHandler(actualMap, data);
        } else {
            resultMap = actualMap.mergeIn([data.event.id.toString()], getClock(data.event));
        }
    }
    return resultMap;
}

export const pushEvent2ClocksMap = function(
    actualMap,
    msg,
    matchCreatedHandler = matchCreated,
    matchDeletedHandler = matchDeleted
) {
    let resultMap = actualMap;
    if (!msg) {
        return resultMap;
    }
    const payload = msg.payload,
        event = msg.payloadEvent;

    if (payload === 'MATCH' && msg.data) {
        resultMap = processMatch(event, actualMap, msg.data, matchCreatedHandler, matchDeletedHandler);
    } else if (payload === 'BET') {
    } else {
        console.error('unknown message', JSON.stringify(msg));
    }

    return resultMap;
};

export const updateClocksMap = function(
    actualMap,
    payloadEvent,
    matchIm,
    matchCreatedHandler = matchCreated,
    matchDeletedHandler = matchDeleted
) {
    if (!matchIm) {
        return actualMap;
    }

    const data = {
        event: {
            id: matchIm.get('id'),
            tick: matchIm.get('tick'),
            clockStopped: matchIm.get('clockStopped'),
            time: matchIm.get('time'),
            countDown: matchIm.get('countDown'),
            eventStatus: matchIm.get('eventStatus')
        }
    };
    return processMatch(null, actualMap, data, matchCreatedHandler, matchDeletedHandler);
};

function pad(str, c, len) {
    let str1 = String(str);
    return Array(Math.max(0, len - str1.length + 1)).join(c) + str1;
}

function toMM(time, countdown) {
    const minutes = countdown ? Math.floor(time / 60) : Math.ceil(time / 60);
    return pad(minutes, '0', 2) + "'";
}

function toSS(time) {
    return pad(Math.floor(time / 60), '0', 2) + ':' + pad(Math.floor(time % 60), '0', 2);
}

const isIn = function(value, array) {
    return array.indexOf(value) > -1;
};

export const registerClocksHandler = function registerClocksHandler(handlerName, clocksPath) {
    reframe.registerHandler(handlerName, [], db =>
        db.updateIn(clocksPath, (clocks = Immutable.Map()) =>
            clocks.reduce(
                (resultClocks, _, clockKey) =>
                    resultClocks.update(clockKey, clock => {
                        const tick = clock.get('tick');
                        const state = clock.get('status');

                        if (clock.get('clockStopped')) {
                            const newTime = clock.get('time');
                            if (newTime > 0) {
                                return clock
                                    .set('mm', toMM(newTime, clock.get('countdown')))
                                    .set('mmss', toSS(newTime));
                            }
                            return clock;
                        }

                        if (!tick || isIn(state, ['CANCELLED', 'INTERRUPTED', 'FINISHED'])) {
                            if (clock.has('mm')) {
                                return clock.remove('mm').remove('mmss');
                            }
                            return clock;
                        }
                        const deltaDir = clock.get('countdown') ? -1 : 1,
                            delta = Math.floor((deltaDir * (Date.now() - clock.get('timestamp'))) / 1000);

                        const newTime = Math.max(0, clock.get('time') + delta);

                        if (newTime > 0) {
                            return clock.set('mm', toMM(newTime, clock.get('countdown'))).set('mmss', toSS(newTime));
                        }
                        if (clock.has('mm')) {
                            return clock.remove('mm').remove('mmss');
                        }
                        return clock;
                    }),
                clocks
            )
        )
    );
};

export const registerClocksSub = function registerClocksSub(subName, clocksPath) {
    reframe.registerSub(subName, (rx, [_, eventId]) => {
        return reframe.indexPath(clocksPath.concat([String(eventId)]));
    });

    reframe.registerSub(subName + '.mm', (rx, [_, eventId]) => {
        return reframe.indexPath(clocksPath.concat([String(eventId)]).concat(['mm']));
    });
};

export const start = function(tickHandlerName) {
    // start ticking
    reframe.dispatch([tickHandlerName]);
    return setInterval(function() {
        reframe.dispatch([tickHandlerName]);
    }, 1000);
};

export const stop = function(timeTicker) {
    clearInterval(timeTicker);
};
